export function accordion() {
    $("body").on("click", ".accordion-heading", function (e) {
        let accordion = $(this).parents(".accordion");
        let parent = $(this).parent();

        if (parent.hasClass("opened")) {
            parent.removeClass("opened").find(".hidden-info").slideUp();
        } else {
            accordion.find(".accordion-item").removeClass("opened").find(".hidden-info").slideUp();
            parent.addClass("opened").find(".hidden-info").slideDown();
        }
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js